import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { useSponsoringContext } from '@/shared/PromoBanner/SponsoringPromoBanner/context/SponsoringContext';

import messages from './messages';

import useStyles from './styles';

const SponsoringPromoBanner: FC = () => {
  const { classes } = useStyles();
  const { hasSponsorLink, sponsorFirstName } = useSponsoringContext();

  if (!hasSponsorLink) return null;

  return (
    <div className={classes.container}>
      <Typography variant="bodyMdBold">
        <FormattedMessage {...messages.title} values={{ sponsorFirstName }} />
      </Typography>
    </div>
  );
};

export default SponsoringPromoBanner;
